export const CC_SURVEY_DETAILS = 'survey';
export const CC_CONTRACT_DETAILS = 'details';
export const CC_CONTRACT_DETAILS_LOGS = 'logs';
